import { useEffect } from "react";
import { Link } from "wouter";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function ThankYou() {
  usePageMeta({
    title: "תודה על פנייתכם | UpSite",
    description: "ההודעה שלכם התקבלה. נציג מאפסייט יחזור אליכם בהקדם.",
  });

  useEffect(() => {
    let robots = document.querySelector('meta[name="robots"]');
    const created = !robots;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, nofollow");
    return () => {
      if (created) robots.parentNode?.removeChild(robots);
    };
  }, []);

  useEffect(() => {
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    w.gtag?.("event", "conversion", {
      send_to: "AW-612055992/OyuTCOb7sKUcELj37KMC",
    });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 gradient-mesh-strong" />
      <div className="absolute top-1/3 left-1/3 w-96 h-96 bg-[#66CDAA]/10 rounded-full blur-[120px]" />
      <div className="container relative z-10 text-center py-32">
        <div className="w-20 h-20 rounded-full bg-[#66CDAA]/20 flex items-center justify-center mx-auto mb-8">
          <CheckCircle2 className="w-10 h-10 text-[#66CDAA]" />
        </div>
        <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 font-[Rubik] leading-tight">
          תודה על פנייתכם!
        </h1>
        <p className="text-lg text-white/60 mb-10 max-w-xl mx-auto leading-relaxed">
          ההודעה שלכם התקבלה בהצלחה. נציג מאפסייט יחזור אליכם בהקדם האפשרי, בדרך כלל תוך יום עסקים אחד.
        </p>
        <Link
          href="/"
          className="glow-btn inline-flex items-center gap-2 text-base px-8 py-4"
        >
          <ArrowLeft className="w-5 h-5" />
          חזרה לדף הבית
        </Link>
      </div>
    </div>
  );
}
